// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4576":"81537ad2","7941":"8238bd89"}[chunkId] + ".chunk.css";
};